import { agreementsRowsPerPage, publicAgreementsRowsPerPage } from "../../../store/agreements";
import { casesRowsPerPage } from "../../../store/cases";
import { formsRowsPerPage, recordsRowsPerPage } from "../../../store/data";
import { documentsRowsPerPage } from "../../../store/documents";
import { refundsRowsPerPage } from "../../../store/refunds";
import { simulationsRowsPerPage } from "../../../store/simulator";
import { TableTypes } from "../LyfeDataTable";

export default function getRowsPerPageStage(type: TableTypes) {
	switch (type) {
		case "forms":
			return formsRowsPerPage;
		case "records":
			return recordsRowsPerPage;
		case "cases":
			return casesRowsPerPage;
		case "agreements":
			return agreementsRowsPerPage;
		case "publicAgreements":
			return publicAgreementsRowsPerPage;
		case "transactions":
			return refundsRowsPerPage;
		case "documents":
			return documentsRowsPerPage;
		case "simulations":
			return simulationsRowsPerPage;
		default:
			throw new Error(`could not get ActivePage state from recoil store for ${type}.`);
	}
}
